export default {
  placeholder: 'Wählen Sie einen Tag',
};
